module.exports = __webpack_public_path__ + "img/jacobus_06.7da542b9.png";